export default "__VITE_ASSET__DkwMA43$__"